import Container from '@mui/material/Container'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import { Form, Formik } from 'formik'
import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Logo } from 'src/assets/Logo'
import Button from 'src/components/Button/Button'
import Card from 'src/components/Card/Card'
import TextInput from 'src/components/TextInput/TextInput'
import config from 'src/config'
import getApiErrorTitle from 'src/helpers/getApiErrorTitle'
import {
  passwordResetComplete,
  PasswordResetCompleteRequest,
} from 'src/packages/api'
import { Content, Footer } from 'src/pages/auth/styling'
import * as Yup from 'yup'

type ResetCompleteValues = {
  password: string
  resetToken?: string
}

const resetCompleteSchema = Yup.object().shape({
  password: Yup.string().required('Password is required'),
  resetToken: Yup.string().required('Token is required in url'),
})

export default function Complete() {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const token = params.get('token')
  const [error, setError] = useState<string | null>(null)

  return (
    <Container maxWidth="xs">
      <Card>
        <Formik
          initialValues={{
            password: '',
            resetToken: token || undefined,
          }}
          onSubmit={async (values: ResetCompleteValues) => {
            setError(null)
            try {
              await passwordResetComplete(
                config,
                values as PasswordResetCompleteRequest
              )
              navigate('/login')
            } catch (e) {
              setError(getApiErrorTitle(e))
            }
          }}
          validationSchema={resetCompleteSchema}
          validateOnChange={false}
          validateOnBlur={false}
        >
          {(formik) => (
            <Form>
              <Content>
                <Logo />
                <TextInput
                  onChange={formik.handleChange('password')}
                  value={formik.values.password}
                  label="new password"
                  placeholder="new password"
                  type="new-password"
                  validationError={
                    formik.errors.password ? formik.errors.password : undefined
                  }
                  variant={'standard'}
                />
              </Content>
              <Footer>
                <Button href="/login" title="Login" />
                <Button
                  title="submit"
                  onClick={formik.submitForm}
                  variant="contained"
                />
              </Footer>
            </Form>
          )}
        </Formik>
      </Card>
      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={() => setError(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{ position: 'relative', top: 0, mt: 2 }}
      >
        <Alert
          onClose={() => setError(null)}
          severity="error"
          sx={{ width: '100%' }}
        >
          {error}
        </Alert>
      </Snackbar>
    </Container>
  )
}
